import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Routes from './Routes';

function App() {
  return (
    <Routes />
  );
}

export default App;
